import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Link, Switch, Route, Redirect } from "react-router-dom";
import About from "./pages/about";
import Contact from "./pages/contact";
import Department from "./pages/department";
import Landing from "./pages/landing";
import Login from "./pages/login";

import Dashboard from "./pages/dashboard";
import Exam from "./pages/exam";
import Finish from "./pages/finish";

const App = () => {
    return (
        <Router>
            <Switch>
                <Route path="/" exact>
                    <Landing />
                </Route>
                <Route path="/about">
                    <About />
                </Route>
                <Route path="/department">
                    <Department />
                </Route>
                <Route path="/contact">
                    <Contact />
                </Route>
                <LoginRoute path="/app/login">
                    <Login />
                </LoginRoute>
                <DashboardRoute path="/app" exact>
                    <Dashboard />
                </DashboardRoute>
                <DashboardRoute path="/app/start" exact>
                    <Exam />
                </DashboardRoute>
                <DashboardRoute path="/app/finish" exact>
                    <Finish />
                </DashboardRoute>
            </Switch>
        </Router>
    )
}

/**
 * Define route for protecting user Dashboard
 */
const DashboardRoute = function({ children, ...props }) {
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    if (!authUser || !authUser.id) {
        return (
            <Route
                {...props}
                render={({ location }) => (
                    <Redirect
                        to={{
                            pathname: "/app/login",
                            state: { from: location }
                        }}
                    />
                )}
            />
        )
    }

    return (
        <Route {...props}>
            {children}
        </Route>
    )
}

/**
 * Define route for protecting Login page
 */
const LoginRoute = function({ children, ...props }) {
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    if (authUser && authUser.id) {
        return (
            <Route
                {...props}
                render={({ location }) => (
                    <Redirect
                        to={{
                            pathname: "/app",
                            state: { from: location }
                        }}
                    />
                )}
            />
        )
    }

    return (
        <Route {...props}>
            {children}
        </Route>
    )
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);